import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3px9mb2kv: FaireProductEntity = {
  token: "p_f3px9mb2kv",
  type: "product",
  name: "Solid Textured Short Sleeve Wide Leg Pants Lounge Set TP5504",
  brandToken: "b_357aiy2qup",
  brandName: "7th Ray",
  imageUrl:
    "https://cdn.faire.com/fastly/8f033e88fba22b0506208cc34289044926f045b3752ced94f96251507bf6b970.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23cf0dfb112d817d19d26540566d7bcffa9cb1bdd064332ca077a510345e5d58.jpeg",
    "https://cdn.faire.com/fastly/6e5eeb42d00bcfd7703318f031a37d05d672e10aaf06ef478eaf89ff8947e1a9.jpeg",
    "https://cdn.faire.com/fastly/d49253f3b7e12dfeb44f685825c087f02158c0204b13e83ce580b4b0540c48b3.jpeg",
    "https://cdn.faire.com/fastly/a33bc6d61922bfb4bb0b231e47defc9968d7973ef9a0f30b6f6d94736b41cbc4.jpeg",
    "https://cdn.faire.com/fastly/906b2f29348cf4eed1cc1b5ce8a979676a56a1c5ca4ec837b37c0759b555b93a.jpeg",
    "https://cdn.faire.com/fastly/8e691dbdfbff6f82d1bf2206dda4945ca09b556c3faeb24668e841aef928d471.jpeg",
    "https://cdn.faire.com/fastly/67cd3cea5089c500e1cfce6d32bbc7cc299256f5493bdbf4b680e02f109186ed.jpeg",
    "https://cdn.faire.com/fastly/471d873ceae611160e2090b1adb41ed157b03ac505eebda6d6c1ebeff16a1c80.jpeg",
    "https://cdn.faire.com/fastly/5de51f91c389da4b02b905a83fffd30a00a956fc95745aa30bdb55196fe1f285.jpeg",
    "https://cdn.faire.com/fastly/71f037f4a07bbd67d67f6eac3e17963885ffc12bd2df305e78cb2da18dbaaeb8.jpeg",
    "https://cdn.faire.com/fastly/39f1906183f8ffee73736aa7028dc3cfe8e0d8a4daf43c255fa2331f20dc23f9.jpeg",
    "https://cdn.faire.com/fastly/76ec45b107058e85202bd3fe0bf4afe0b5cad1d0628528be3cce2e75ddc82828.jpeg",
    "https://cdn.faire.com/fastly/f07cfeeebab28f07f5083a36afacbc1914f7608a14625392c4cc7c1d5540460b.jpeg",
    "https://cdn.faire.com/fastly/685822abd5333b3e0294158b067f4d2f3dcb77495b118b18449a373f37e1bb02.jpeg",
    "https://cdn.faire.com/fastly/8106b29d4d0d01ace71f45bd26f817222c8921550715585cf06070a3dc044656.jpeg",
    "https://cdn.faire.com/fastly/28c78c30bca416191aa849f5b189bfcf2b47a721a19311c9ff559a23412111fa.jpeg",
    "https://cdn.faire.com/fastly/fd519fb0de7fe0c3db19e03c8297ae891911d414744a51de23034caaeaa29a19.jpeg",
  ],
  priceDollars: 25,
  description:
    "A SOLID TEXTURED LOUNGE SET FEATURING A SHORT SLEEVE TOP, RELAXED FIT, HI LOW HEM, SIDE SLIT AND A RELAXED FIT. WIDE LEG PANTS FEATURING AN ELASTIC WAIST, AND SIDE POCKETS.\n\n*MODEL IS WEARING SIZE SMALL",
  tags: [],
  msrpDollars: 50,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:32.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
